import React from 'react';

import styles from './HowItWorks.scss';
import CustomGrid from '../../controls/grid/CustomGrid';
import InfoSection from './InfoSection';
import Divider from '../../controls/Divider';
import CustomBox from '../../controls/grid/CustomBox';

export default function HowItWorks() {
    return (
        <CustomGrid
            container
            item
            xs={12}
            justify="center"
            spacing="xxl-4"
            className={styles.wrapper}
        >
            <CustomGrid
                item
                md={9}
                xs={12}
            >
                <InfoSection
                    title={loc('how-it-works-first-title')}
                    text={loc('how-it-works-first-text')}
                    imageName="how-it-works"
                />
            </CustomGrid>
            <CustomGrid
                item
                md={9}
                xs={12}
                className={styles.fullWidth}
            >
                <Divider />
            </CustomGrid>
            <CustomGrid
                item
                md={9}
                xs={12}
            >
                <InfoSection
                    reverse
                    title={loc('how-it-works-second-title')}
                    text={loc('how-it-works-second-text')}
                    imageName="how-it-works2"
                />
            </CustomGrid>
        </CustomGrid>
    );
}



// WEBPACK FOOTER //
// ./src/components/Index/sections/HowItWorks.js